import { GroupedSelectOption, ProviderResource } from "./ResourceTable.types";

export function groupSelectOptionsOnProperty(
  providerResources: ProviderResource[],
) {
  return providerResources.reduce((groupedOptions, resource) => {
    const group = groupedOptions.find(
      (item) => item.label === resource.accountAddress,
    );
    if (group) {
      group.options.push({ value: resource.id, label: resource.name });
    } else {
      groupedOptions.push({
        label: resource.accountAddress,
        options: [{ value: resource.id, label: resource.name }],
      });
    }
    return groupedOptions;
  }, [] as GroupedSelectOption[]);
}
